/**
 * Who runs Sekretly, as the legal pages state it. One place, so the Terms, the
 * Host Agreement and the Privacy Notice always agree. Name and address are spelled
 * as in the platform settings (company_legal_name, company_address), which the
 * invoices use.
 */
export const COMPANY = {
  name: 'Sekretly Lda.',
  /** Número de Identificação de Pessoa Coletiva. */
  nipc: '519601505',
  addressLines: [
    'Rua Doutor Joao Afonso de Almeida 521 - AP 201',
    '4800-045 - Guimarães',
    'Portugal',
  ],
  /** One address for every kind of contact: support, privacy, security, trust and safety. */
  email: 'info@sekretly.com',
  /** Courts that settle disputes (consumers keep the right to their own courts). */
  courts: 'Guimarães',
} as const;

/** The legal pages are drafts until a lawyer has reviewed them; set to false then. */
export const LEGAL_IS_DRAFT = true;

/** Last time the legal text changed, as the pages print it. */
export const LEGAL_UPDATED = { en: 'November 2026', pt: 'novembro de 2026' } as const;
